import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

export interface StructuredLocation { direccion: string; codigo_postal: string; localidad: string; provincia: string; latitud: number | null; longitud: number | null; }

@Component({ selector: 'app-location-picker', standalone: true, imports: [CommonModule, ReactiveFormsModule], templateUrl: './location-picker.component.html' })
export class LocationPickerComponent {
  private static siguiente = 0;
  /** Identificador único del campo para asociar la etiqueta. */
  readonly idCampo = 'ubicacion-' + (++LocationPickerComponent.siguiente);
  @Input() label = 'Ubicación';
  @Input() value: StructuredLocation = { direccion: '', codigo_postal: '', localidad: '', provincia: '', latitud: null, longitud: null };
  @Output() locationChange = new EventEmitter<StructuredLocation>();
  editing = false;
  search = new FormControl('');
  results: any[] = [];
  constructor(private http: HttpClient) {}
  open(): void { this.editing = true; this.results = []; this.search.setValue(this.value.direccion); }
  find(): void {
    const query = String(this.search.value || '').trim(); if (!query) return;
    this.http.get<any[]>('https://nominatim.openstreetmap.org/search', { params: { q: query, format: 'jsonv2', addressdetails: '1', limit: '5' } }).subscribe({ next: r => this.results = r, error: () => this.results = [] });
  }
  choose(result: any): void {
    const a = result.address || {};
    this.value = { direccion: result.display_name || '', codigo_postal: a.postcode || '', localidad: a.city || a.town || a.village || a.municipality || '', provincia: a.state || a.province || '', latitud: Number(result.lat) || null, longitud: Number(result.lon) || null };
    this.locationChange.emit(this.value); this.editing = false;
  }
  useCurrent(): void { navigator.geolocation?.getCurrentPosition(p => { this.value = { ...this.value, latitud: p.coords.latitude, longitud: p.coords.longitude }; this.locationChange.emit(this.value); }); }
}
